"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftStatusToJSON = exports.DraftStatusFromJSONTyped = exports.DraftStatusFromJSON = exports.DraftStatus = void 0;
/**
 * Status of the campaign draft.
 * @export
 */
exports.DraftStatus = {
    Active: 'ACTIVE',
    Archived: 'ARCHIVED',
    Complete: 'COMPLETE',
    PendingAdvertiserReview: 'PENDING_ADVERTISER_REVIEW'
};
function DraftStatusFromJSON(json) {
    return DraftStatusFromJSONTyped(json, false);
}
exports.DraftStatusFromJSON = DraftStatusFromJSON;
function DraftStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DraftStatusFromJSONTyped = DraftStatusFromJSONTyped;
function DraftStatusToJSON(value) {
    return value;
}
exports.DraftStatusToJSON = DraftStatusToJSON;
